"use client";
import SvgProfile from "./common-header-icons/SvgProfile";
import MenuLink from "./menu/MenuLink";
import SvgAddressBook from "./common-header-icons/SvgAddressBook";
import SvgOrders from "./common-header-icons/SvgOrders";
import SvgAppointments from "./common-header-icons/SvgAppointments";
import SvgConsultations from "./common-header-icons/SvgConsultations";
import { useGetProfileQuery } from "@/api/AppApi/services/auth";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import SvgChildren from "./common-header-icons/SvgChildren";
import SvgApplications from "./common-header-icons/SvgApplications";
import { PagesPaths } from "@/utils/functions/pages-paths";
import NextImage from "@/app/components/lib/NextImage";
import { IsTopWinner } from "@/utils/functions/global-constants";
import SvgPayment from "./common-header-icons/SvgPayment";
import { useTranslation } from "@/hooks/localization/useTranslations";
import SvgLoyality from "./common-header-icons/SvgLoyality";
interface Props {
  isMobile?: boolean;
}
const UserMenuContent: React.FC<Props> = ({ isMobile }) => {
  const t = useTranslation();
  const getComapny = useGetCompanyQuery();
  const features = getComapny.data?.result?.theme?.settings?.features;
  const getProfile = useGetProfileQuery();
  const user = getProfile.data?.result;
  let items = [
    {
      title: { Svg: <SvgProfile />, text: t.my_profile },
      href: PagesPaths.profile,
    },
    {
      title: { Svg: <SvgAddressBook />, text: t.address_book },
      href: PagesPaths.address_book,
    },
  ];
  getComapny.data?.result?.loyalty_system?.active &&
    items.push({
      title: { Svg: <SvgLoyality />, text: t.loyalty },
      href: PagesPaths.my_loyalty,
    });
  features?.orders &&
    items.push({
      title: { Svg: <SvgOrders />, text: t.my_orders },
      href: PagesPaths.orders,
    });
  features?.appointments &&
    items.push({
      title: { Svg: <SvgAppointments />, text: t.my_appointments },
      href: PagesPaths.appointments,
    });
  features?.consultations &&
    items.push({
      title: { Svg: <SvgConsultations />, text: t.my_consultations },
      href: PagesPaths.consultations,
    });
  (features?.school &&
    items.push({
      title: { Svg: <SvgChildren />, text: t.my_students },
      href: PagesPaths.students,
    }),
    IsTopWinner(getComapny?.data?.result!) &&
      items.push({
        title: { Svg: <SvgChildren />, text: t.my_forms },
        href: PagesPaths.agentsForms,
      }),
    features?.school &&
      items.push({
        title: { Svg: <SvgApplications />, text: t.my_applications },
        href: PagesPaths.applications,
      }));
  features?.school &&
    items.push({
      title: { Svg: <SvgPayment />, text: t.my_payments },
      href: PagesPaths.student_payments,
    });

  return (
    <>
      <div className="d-flex justify-content-center">
        {isMobile && (
          <div className="avatar-container">
            <NextImage
              alt={"user"}
              src={user?.avatar ?? ""}
              width={100}
              height={100}
              objectFit="cover"
            />
          </div>
        )}
      </div>
      <div className="user-info text-nowrap">
        <div className="user-name">{user?.name}</div>
        <div className="user-email">{user?.email}</div>
      </div>
      <div
        className="d-flex flex-column"
        style={
          isMobile
            ? {
                gap: 16,
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }
            : {}
        }
      >
        {items.map((item, key) => (
          <MenuLink
            key={key}
            isMobile={isMobile}
            title={item?.title}
            href={item?.href}
          />
        ))}
      </div>
    </>
  );
};

export default UserMenuContent;
